<template>
  <div id="property-info">
    <h2 class="mt-3 pb-1 border-bottom">Property Information</h2>

    <dl>
      <dt>Tax Year/Pay Year</dt>
      <dd>{{ taxYearPayYear || "No Info" }}</dd>

      <dt>Parcel Number</dt>
      <dd>{{ item.StateKey || "No Info" }}</dd>

      <dt>Duplicate Number</dt>
      <dd>{{ item.BillingDuplicateNumber }}</dd>

      <dt>Property Type</dt>
      <dd>{{ item.TaxType || "No Info" }}</dd>

      <dt>Tax Unit / Description</dt>
      <dd>{{ item.TaxUnitDescription || "No Info" }}</dd>

      <dt>Property Class</dt>
      <dd>{{ item.CLASSDESCRIPTION || "No Info" }}</dd>

      <dt>Mortgage Company</dt>
      <dd>{{ item.MortgageCompany || "None" }}</dd>

      <dt v-if="item.MortgageCompany">Mtg Company Last Changed</dt>
      <dd v-if="item.MortgageCompanyLastChangedDate">
        {{ item.MortgageCompanyLastChangedDate | toDate }}
      </dd>

      <dt>TIF</dt>
      <dd>{{ item.TifArea || "None" }}</dd>

      <dt>Homestead Credit Filed?</dt>
      <dd>{{ item.HomesteadCreditFiled === "T" ? "Yes" : "No" }}</dd>

      <dt v-if="taxYearPayYear < '2016 / 2017'">Homestead</dt>
      <dd v-if="taxYearPayYear < '2016 / 2017'">
        {{ item.HomesteadCredit || "No Info" }}
      </dd>

      <dt>Over 65 Circuit Breaker?</dt>
      <dd>{{ item.Over65CircuitBreaker === "T" ? "Yes" : "No" }}</dd>

      <dt>Legal Description</dt>
      <dd>
        <span class="text-danger"> Note: Not to be used on legal documents</span
        ><br /><span v-html="item.LEGALDESCRIPTION" />
      </dd>

      <dt v-if="taxYearPayYear < '2016 / 2017'">PTRC Bus / Res</dt>
      <dd v-if="taxYearPayYear < '2016 / 2017'">{{ ptrc || "No Info" }}</dd>

      <dt>Section-Township-Range</dt>
      <dd>
        {{
          item.PROPERTYSECTION && item.PROPERTYTOWNSHIP && item.PROPERTYRANGE
            ? `${item.PROPERTYSECTION}, ${item.PROPERTYTOWNSHIP}, ${item.PROPERTYRANGE}`
            : "No Info"
        }}
      </dd>

      <dt>Parcel Acres</dt>
      <dd>{{ item.PROPERTYACRES || "No Info" }}</dd>

      <dt>Lot Number</dt>
      <dd>{{ item.PROPERTYLOTNUMBER || "No Info" }}</dd>

      <dt>Block/Subdivision</dt>
      <dd>{{ item.PropertyBlockSubdivision || "No info" }}</dd>
    </dl>
  </div>
</template>

<style scoped>
/* responsive <dl> */
@media (min-width: 576px) {
  dl {
    column-count: 2;
  }
  dd {
    padding-left: 1em;
  }
}
@media print {
  dl {
    column-count: 2;
  }
}
dt {
  break-after: avoid-column;
}
</style>

<script>
export default {
  computed: {
    taxYearPayYear() {
      return this.item.TaxType === "Mobile"
        ? this.item.PAYYEAR + " / " + this.item.PAYYEAR
        : this.item.PAYYEAR - 1 + " / " + this.item.PAYYEAR;
    },
    formattedMailingAddress() {
      let html = this.item.MAILINGADDRESS1 + "<br>";
      if (this.item.MAILINGADDRESS2) {
        html = html + this.item.MAILINGADDRESS2 + "<br>";
      }
      if (this.item.MAILINGCITY) {
        html = html + this.item.MAILINGCITY + ", ";
      }
      if (this.item.MAILINGSTATE) {
        html = html + this.item.MAILINGSTATE + "  ";
      }
      if (this.item.MAILINGZIPCODE) {
        html = html + this.item.MAILINGZIPCODE;
      }
      if (this.item.MAILINGZIPPLUS4) {
        html = html + "-" + this.item.MAILINGZIPPLUS4;
      }
      if (this.item.MAILINGCOUNTRY) {
        html = html + "<br>" + this.item.MAILINGCOUNTRY;
      }
      return html;
    },
    ptrc() {
      return this.item.PTRC_Bus + " / " + this.item.PTRC_Res;
    },
  },
  props: {
    county: {
      type: Object,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>
